import { jsx as _jsx } from "react/jsx-runtime";
import Box from '../box';
import { bg, borderRaduis, boxShadow } from './consts';
export const TooltipContent = ({ children, fontSize = '16px', maxWidth = '400px' }) => (_jsx(Box, { bg: bg, borderRadius: borderRaduis, boxShadow: boxShadow, className: "vui-tooltip-content", color: "white", fontSize: fontSize, m: 1, maxW: maxWidth, overflowY: "auto", p: 1, pl: 2, pr: 2, children: children }));
TooltipContent.displayName = 'TooltipContent';
